import HomeRedirect from "./home_redirect";
import { connect } from "react-redux";
import { withRouter } from "react-router";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    currentRole: state.user.currentRole,
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

const HomeRedirectWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeRedirect));

export default HomeRedirectWrapper;
